import React from 'react';
import { Card } from './ui/card';
import { Shield, Clock, Award, Users, Globe2, ThumbsUp } from 'lucide-react';

export const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Shield,
      title: 'Trusted Expertise',
      description: 'UK-based company with proven track record in visa and immigration services since 2022.'
    },
    {
      icon: Award,
      title: 'High Success Rate',
      description: '98% visa approval rate thanks to our meticulous attention to detail and expert guidance.'
    },
    {
      icon: Clock,
      title: 'Fast Processing',
      description: 'Efficient document preparation and submission ensuring timely application processing.'
    },
    {
      icon: Users,
      title: 'Personalized Service',
      description: 'Individual attention to each case with customized solutions for your specific needs.'
    },
    {
      icon: Globe2,
      title: 'International Experience',
      description: 'Extensive knowledge of Mexican visa requirements and international immigration laws.'
    },
    {
      icon: ThumbsUp,
      title: 'Client Satisfaction',
      description: 'Dedicated support team ensuring smooth communication throughout the entire process.'
    }
  ];

  return (
    <section id="why-us" className="py-20 sm:py-24 lg:py-32 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Choose VISA INTELLIGENCE?
          </h2>
          <p className="text-lg text-muted-foreground">
            We combine expertise, efficiency, and personalized service to make your visa journey seamless
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {reasons.map((reason, index) => (
            <Card
              key={index}
              className="p-6 hover:shadow-lg transition-all duration-300 border-2 hover:border-primary/30 group"
            >
              <div className="flex flex-col h-full">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-primary mb-4 group-hover:scale-110 transition-transform">
                  <reason.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">
                  {reason.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </Card>
          ))}
        </div>

        <div className="mt-16 max-w-4xl mx-auto">
          <Card className="bg-gradient-primary border-0 overflow-hidden">
            <div className="p-8 sm:p-10 text-center text-white">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4">
                VISA INTELLIGENCE LTD
              </h3>
              <div className="space-y-2 text-white/90">
                <p className="text-lg">Company Number: 14304138</p>
                <p className="text-lg">Incorporated: 18 August 2022</p>
                <p className="text-lg">257a Whitechapel Road, London, England, E1 1DB</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
